import React, { useState } from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import AddButton from "../../../components/admin/usable/AddButton";
import toast from "react-hot-toast";
import { registerAdmin } from "../../../api/admin/userApi";

const AddUser = ({ setAdminData, Page, Limit, setPageData }) => {
  const [open, setOpen] = useState(false);
  const [FormData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    password: "",
    isAdmin: 1,
    status: 1,
    createdAt: new Date().toISOString(),
  });
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleSubmit = () => {
    if (
      FormData.fullName === "" ||
      FormData.email === "" ||
      FormData.phoneNumber === "" ||
      FormData.password === ""
    ) {
      toast.error("Please fill all the fields");
    } else {
      registerAdmin(
        FormData,
        setFormData,
        setAdminData,
        Page,
        Limit,
        setPageData,
        setOpen,
      );
    }
  };
  return (
    <>
      <AddButton onClick={() => setOpen(true)} text="Add Admin User" />

      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => setOpen(false)}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{ maxWidth: 500, borderRadius: "md", p: 3, boxShadow: "lg" }}
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            sx={{ fontWeight: "lg", mb: 1 }}
          >
            Register Admin here
          </Typography>
          <div className="w-full px-5 space-y-5">
            <div>
              <label htmlFor="password" className="text-black/60 text-xs">
                Full Name <small>(Legal Name)</small>
              </label>
              <input
                type="text"
                placeholder="Enter your full name"
                className="border w-full px-10 py-3 rounded-md focus:outline-none"
                value={FormData.fullName}
                onChange={handleChange}
                id="fullName"
              />
            </div>
            <div className="relative">
              <label htmlFor="phoneNumber" className="text-black/60 text-xs">
                Phone Number
              </label>
              <input
                type="text"
                placeholder="Enter Phone Number"
                className="border w-full px-12 py-3 rounded-md focus:outline-none"
                value={FormData.phoneNumber}
                onChange={handleChange}
                id="phoneNumber"
              />
            </div>
            <div>
              <label htmlFor="password" className="text-black/60 text-xs">
                Email
              </label>
              <input
                type="text"
                placeholder="Enter your email address"
                className="border w-full px-10 py-3 rounded-md focus:outline-none"
                value={FormData.email}
                onChange={handleChange}
                id="email"
              />
            </div>
            <div>
              <label htmlFor="password" className="text-black/60 text-xs">
                Password
              </label>
              <input
                type="text"
                placeholder="Enter your password"
                className="border w-full px-10 py-3 rounded-md focus:outline-none"
                value={FormData.password}
                onChange={handleChange}
                id="password"
              />
            </div>
            <div>
              <button
                onClick={handleSubmit}
                className="bg-[#153875] w-full py-3 rounded-lg text-white text-sm font-semibold scale-100 hover:scale-105 duration-300 active:scale-95"
              >
                Create Now
              </button>
            </div>
          </div>
        </Sheet>
      </Modal>
    </>
  );
};

export default AddUser;
